import React, { useState } from 'react';
import Box from '@mui/material/Box';
import OnTruckSearchForm from './OnTruckSearchForm';
import OnTruckSearchTable from './OnTruckSearchTable';
import operationsHelpers from '../../helpers/operations';

function OnTruckSearch(props) {

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [truckNum, setTruckNum] = useState('');
    const [trackingNum, setTrackingNum] = useState('');
    const [packages, setPackages] = useState([]);

    const handleDateChange = (date, field) => {
        let func = setStartDate;
        if (field === "endDate") func = setEndDate;
        if (date !== null) {
            func({formatted: date.format("YYYY-MM-DD"), full: date});
        } else {
            func(date);
        };
    };

    const getPackages = async () => {
        props.setLoading(true);
        try {
            const payload = {
                start_date: startDate ? startDate.formatted : null,
                end_date: endDate ? endDate.formatted : null,
                truck_number: truckNum ? truckNum : null,
                tracking_number: trackingNum ? trackingNum : null
            };
            const res = await operationsHelpers.getPackagesOnTruck(payload, props.company, props.token);
            setPackages(res);
           
        } catch(err) {
            console.log('getBuilds', err);
            props.toast.error('Failed to get builds!');
        } finally {
            props.setLoading(false);
        };
    };

    const clearSearch = async () => {
        setStartDate(null);
        setEndDate(null);
        setTruckNum('');
        setTrackingNum('');
        setPackages([]);
    };

    const exportPackages = async () => {
        const today = new Date();
        const formattedDate = `${today.getMonth() + 1}.${today.getDate()}.${today.getFullYear().toString().slice(-2)}`;
        let data = [
            ["truck_number", "tracking_number", "date"].join(",")
        ];
        for (let pack of packages) {
            data.push(
                [pack.truck_number, pack.tracking_number, pack.date].join(",")
            );
        };
        let csv = data.join("\n");
        let uri = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        let a = document.createElement("a");
        a.setAttribute("href", uri);
        a.setAttribute("download", `${formattedDate} On Truck.csv`);
        document.body.appendChild(a);
        a.click();
    };

    return(
        <Box className = {props.isMobile ? "mobile-top" : "desktop-top"} sx = {{display: 'flex', flexDirection: 'column'}}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 2}}>
                <h1>On Truck Search</h1>
                <OnTruckSearchForm
                    isMobile = {props.isMobile}
                    handleDateChange = {handleDateChange}
                    startDate = {startDate?.full}
                    endDate = {endDate?.full}
                    truckNum = {truckNum}
                    setTruckNum = {setTruckNum}
                    setTrackingNum = {setTrackingNum}
                    trackingNum = {trackingNum}
                    clearSearch = {clearSearch}
                    getPackages = {getPackages}
                    exportPackages = {exportPackages}
                    packages = {packages}
                />
                <OnTruckSearchTable 
                    isMobile = {props.isMobile}
                    packages = {packages}
                />
            </Box>
        </Box>
    )
}

export default OnTruckSearch;